import { calculateProyectedData } from "./Table/utils";
import {
  INITIAL_CHANNELS_STATE,
  INITIAL_COLUMNS_STATE,
  INITIAL_LISTINGTYPENAMES_STATE,
} from "./Toolbar/utils";

export const pricingStoreSlice = (set) => ({
  pricingOwners: [],
  pricingDomains: [],
  pricingChannels: INITIAL_CHANNELS_STATE,
  pricingListingtypenames: INITIAL_LISTINGTYPENAMES_STATE,
  pricingCategoryPath: [],
  pricingSelectedOwners: null,
  pricingSelectedListingtypename: "Todas",
  pricingSelectedDomain: null,
  pricingSelectedChannel: [],
  pricingSelectedBrand: null,
  pricingSelectedCategoryPath: null,
  pricingColumns: INITIAL_COLUMNS_STATE,
  pricingSearch: [],
  pricingShowCard: true,
  pricingShowInactive: true,
  pricingShowFlag: false,
  pricingCostHistoryData: {
    open: false,
    data: null,
  },
  pricingEditedRows: {},
  pricingRowsSelectionModel: [],
  pricingTableCustomizationTooltip: false,

  setPricingOwners: (owners) => set(() => ({ pricingOwners: owners })),
  setPricingDomains: (domains) => set(() => ({ pricingDomains: domains })),

  setPricingSelectedOwners: (owners) =>
    set(() => ({ pricingSelectedOwners: owners })),

  togglePricingSelectedOwners: (owner) =>
    set((state) => {
      if (state.pricingSelectedOwners.includes(owner)) {
        return {
          pricingSelectedOwners: state.pricingSelectedOwners.filter(
            (item) => item !== owner
          ),
        };
      }

      return {
        pricingSelectedOwners: [...state.pricingSelectedOwners, owner],
      };
    }),
  setPricingSelectedListingtypename: (listingtypename) =>
    set(() => ({ pricingSelectedListingtypename: listingtypename })),
  clearPricingSelectedListingtypename: () =>
    set(() => ({ pricingSelectedListingtypename: "Todas" })),
  clearPricingSelectedOwners: () =>
    set(() => ({
      pricingSelectedOwners: null,
    })),
  togglePricingSelectedDomain: (domain) =>
    set((state) => {
      const newDomain = state.pricingSelectedDomain === domain ? null : domain;
      return {
        pricingSelectedDomain: newDomain,
      };
    }),
  clearPricingSelectedDomain: () =>
    set(() => ({
      pricingSelectedDomain: null,
    })),

  setPricingSelectedChannel: (channelsArray) =>
    set((state) => {
      if (channelsArray.includes("MELI")) {
        return {
          pricingSelectedListingtypename: state.pricingSelectedListingtypename,
          pricingSelectedChannel: channelsArray,
          pricingColumns: { ...state.pricingColumns, listingtypename: true },
        };
      } else {
        return {
          // Si no es MELI, se limpia el tipo de publicación
          pricingSelectedListingtypename: "Todas",
          pricingSelectedChannel: channelsArray,
          pricingColumns: { ...state.pricingColumns, listingtypename: false },
        };
      }
    }),

  setPricingSelectedCategoryPath: (categoryPath) =>
    set((state) => {
      const newCategoryPath =
        state.pricingSelectedCategoryPath === categoryPath
          ? null
          : categoryPath;
      return {
        pricingSelectedCategoryPath: newCategoryPath,
      };
    }),
  clearPricingSeletedCategoryPath: () =>
    set(() => ({
      pricingSelectedCategoryPath: null,
    })),
  clearPricingSeletedChannel: () =>
    set((state) => ({
      pricingSelectedChannel: [],
      pricingColumns: { ...state.pricingColumns, listingtypename: true },
    })),
  pricingClearFilters: () =>
    set((state) => ({
      pricingSelectedChannel: [],
      pricingSelectedDomain: null,
      pricingSelectedListingtypename: "Todas",
      pricingColumns: { ...state.pricingColumns, listingtypename: true },
    })),
  setPricingSelectedBrand: (brand) =>
    set((state) => {
      const newBrand = state.pricingSelectedBrand === brand ? null : brand;
      return {
        pricingSelectedBrand: newBrand,
      };
    }),
  clearPricingSelectedBrand: () =>
    set(() => ({
      pricingSelectedBrand: null,
    })),

  togglePricingColumns: (field, value) =>
    set((state) => ({
      pricingColumns: {
        ...state.pricingColumns,
        [field]: value,
      },
    })),
  resetPricingColumns: () =>
    set(() => ({
      pricingColumns: INITIAL_COLUMNS_STATE,
    })),
  setPricingSearch: (newSearch) =>
    set((state) => {
      const current = state.pricingSearch || [];

      const incoming = Array.isArray(newSearch) ? newSearch : [newSearch];

      const normalized = incoming
        .map((x) => {
          if (!x) return null;

          if (typeof x === "object" && x.value && x.type) {
            const skuValue = x.sku || "";
            return {
              value: x.value.trim(),
              type: x.type,
              sku: Array.isArray(skuValue) ? skuValue : skuValue,
            };
          }

          if (typeof x === "string" && x.trim()) {
            return { value: x.trim(), type: "All", sku: "" };
          }
          return null;
        })
        .filter((x) => x !== null);

      // Filtrar duplicados por valor
      const cleaned = normalized.filter(
        (item) =>
          !current.some((c) => {
            const currentValue = typeof c === "string" ? c : c.value;
            return currentValue === item.value;
          })
      );

      return { pricingSearch: [...current, ...cleaned] };
    }),
  deletePricingSearch: (searchItem) =>
    set((state) => {
      const valueToDelete =
        typeof searchItem === "string" ? searchItem : searchItem.value;

      return {
        pricingSearch: state.pricingSearch.filter((s) => {
          const currentValue = typeof s === "string" ? s : s.value;
          return currentValue !== valueToDelete;
        }),
      };
    }),
  togglePricingShowCard: () =>
    set((state) => ({
      pricingShowCard: !state.pricingShowCard,
    })),
  togglePricingShowInactive: () =>
    set((state) => ({ pricingShowInactive: !state.pricingShowInactive })),
  setPricingShowInactive: (paused) =>
    set((state) => ({ pricingShowInactive: paused })),
  togglePricingShowFlag: () =>
    set((state) => ({ pricingShowFlag: !state.pricingShowFlag })),
  setPricingShowFlag: (value) => set(() => ({ pricingShowFlag: value })),
  openPricingCostHistoryModal: (data) =>
    set(() => ({
      pricingCostHistoryData: {
        open: true,
        data,
      },
    })),
  closePricingCostHistoryModal: () =>
    set(() => ({
      pricingCostHistoryData: {
        open: false,
        data: null,
      },
    })),

  addPricingEditedRow: (editedRow) =>
    set((state) => {
      return {
        pricingEditedRows: {
          ...state.pricingEditedRows,
          [editedRow.id]: editedRow,
        },
      };
    }),

  editUsdCost: (row, value, dolar, countryName) =>
    set((state) => {
      if (
        isNaN(value) &&
        !row.pvpdisbyte_proyectado &&
        state.pricingEditedRows[row.id]
      ) {
        const editedRowsCopy = { ...state.pricingEditedRows };
        delete editedRowsCopy[row.id];

        return {
          pricingEditedRows: editedRowsCopy,
        };
      }

      if (row.pvpdisbyte_proyectado && row.pvpdisbyte_proyectado > 0) {
        return {
          pricingEditedRows: {
            ...state.pricingEditedRows,
            [row.id]: {
              ...row,
              ...calculateProyectedData({
                usdcost_proyectado: value,
                pvpdisbyte_proyectado: row.pvpdisbyte_proyectado,
                dolar,
                pais: countryName,
                row,
                // Mantiene aplicado el último valor traído desde MELI durante ediciones
                // sucesivas, hasta que llegue uno nuevo (evita flicker entre row.fs y meli.fs).
                meliListCostOverride: row._meliListCostOverride,
              }),
              usdcost_proyectado: isNaN(value) ? undefined : value,
            },
          },
        };
      } else {
        return {
          pricingEditedRows: {
            ...state.pricingEditedRows,
            [row.id]: {
              ...row,
              usdcost_proyectado: isNaN(value) ? undefined : value,
              localcost_proyectado: isNaN(value)
                ? 0
                : +(value * dolar).toFixed(2),
            },
          },
        };
      }
    }),

  editPvpDisbyte: (row, value, dolar, countryName) =>
    set((state) => {
      if (
        isNaN(value) &&
        !row.usdcost_proyectado &&
        state.pricingEditedRows[row.id]
      ) {
        const editedRowsCopy = { ...state.pricingEditedRows };
        delete editedRowsCopy[row.id];

        return {
          pricingEditedRows: editedRowsCopy,
        };
      }

      if (!isNaN(value)) {
        return {
          pricingEditedRows: {
            ...state.pricingEditedRows,
            [row.id]: {
              ...row,
              ...calculateProyectedData({
                usdcost_proyectado: row.usdcost_proyectado ?? 0,
                pvpdisbyte_proyectado: value,
                dolar,
                pais: countryName,
                row,
                // Mantiene aplicado el último valor de MELI durante ediciones sucesivas.
                meliListCostOverride: row._meliListCostOverride,
              }),
              pvpdisbyte_proyectado: value,
            },
          },
        };
      } else {
        return {
          pricingEditedRows: {
            ...state.pricingEditedRows,
            [row.id]: {
              ...row,
              pvpbuyer_proyectado: 0.0,
              discount_proyectado: 0,
              margen_proyectado: 0,
              freeshipping_proyectado: false,
              roi_proyectado: 0,
              pvp_proyectado: 0,
              pvpdisbyte_proyectado: isNaN(value) ? undefined : value,
              costo_proyectado: null,
              pvpdisbytenoiva_proyectado: null,
              melifeeadjnoiva_proyectado: null,
              freeshippingnoiva_proyectado: null,
              fixratenoiva_proyectado: null,
              profit_proyectado: null,
            },
          },
        };
      }
    }),

  // Aplica el list_cost obtenido desde Mercado Libre (vía backend) al recálculo de
  // proyectados. Si la fila tiene freeshipping=true, el override entra como FS;
  // si freeshipping=false, entra como fixrate (costo operativo MX/CO).
  // El override se persiste en `_meliListCostOverride` para que las ediciones siguientes
  // del usuario lo reutilicen y no haya flicker entre el valor cacheado y el de MELI.
  applyMeliFreeShipping: (rowId, meliListCost, dolar, countryName) =>
    set((state) => {
      const editedRow = state.pricingEditedRows[rowId];
      if (!editedRow) return state;
      if (!meliListCost || meliListCost <= 0) return state;

      const pvpProy = editedRow.pvpdisbyte_proyectado;
      const usdProy = editedRow.usdcost_proyectado ?? 0;
      if (!pvpProy || pvpProy <= 0) return state;

      return {
        pricingEditedRows: {
          ...state.pricingEditedRows,
          [rowId]: {
            ...editedRow,
            ...calculateProyectedData({
              usdcost_proyectado: usdProy,
              pvpdisbyte_proyectado: pvpProy,
              dolar,
              pais: countryName,
              row: editedRow,
              meliListCostOverride: meliListCost,
            }),
            pvpdisbyte_proyectado: pvpProy,
            usdcost_proyectado: usdProy,
            _meliListCostOverride: meliListCost,
          },
        },
      };
    }),

  clearPricingEditedRows: () => set(() => ({ pricingEditedRows: {} })),
  updatePricingRowsSelectionModelAndEditedRows: (newRowSelectionModel) =>
    set((state) => {
      let editedRowsCopy;

      if (newRowSelectionModel?.length === 0) {
        editedRowsCopy = {};
      } else {
        editedRowsCopy = { ...state.pricingEditedRows };
        const validRows = [];
        newRowSelectionModel.forEach((rowId) => {
          if (editedRowsCopy[rowId]) {
            validRows.push(rowId);
          }
        });

        editedRowsCopy = validRows.reduce((acc, rowId) => {
          acc[rowId] = editedRowsCopy[rowId];
          return acc;
        }, {});
      }

      return {
        pricingEditedRows: editedRowsCopy,
        pricingRowsSelectionModel: newRowSelectionModel,
      };
    }),
  addPricingRowSelection: (rowId) =>
    set((state) => {
      if (state.pricingRowsSelectionModel.includes(rowId)) {
        return {
          pricingRowsSelectionModel: state.pricingRowsSelectionModel,
        };
      }
      return {
        pricingRowsSelectionModel: [...state.pricingRowsSelectionModel, rowId],
      };
    }),
  removePricingRowSelection: (rowId) =>
    set((state) => {
      return {
        pricingRowsSelectionModel: state.pricingRowsSelectionModel.filter(
          (id) => id !== rowId
        ),
      };
    }),
  clearPricingRowsSelectionModel: () =>
    set(() => ({ pricingRowsSelectionModel: [] })),
  togglePricingTableCustomizationTooltip: () =>
    set((state) => ({
      pricingTableCustomizationTooltip: !state.pricingTableCustomizationTooltip,
    })),

  openPricingTableCustomizationTooltip: () =>
    set(() => ({
      pricingTableCustomizationTooltip: true,
    })),

  closePricingTableCustomizationTooltip: () =>
    set(() => ({
      pricingTableCustomizationTooltip: false,
    })),
});
